import { useContext } from 'react';

import type { ProfileFormContextValue } from '../types/profileFormContext';
import { ProfileFormContext } from './profileFormContext';

export function useProfileForm(): ProfileFormContextValue {
  const context = useContext(ProfileFormContext);
  if (!context) {
    throw new Error('useProfileForm must be used within ProfileFormProvider');
  }

  return context;
}
